import comp from "./TableBulkActions";
export default comp;
